import { SkeletonRow } from '@/components/Skeleton';
import { ErrorState } from '@/components/ErrorState';
import { ModelConfigurationPanel } from '@/pages/modelConfiguration/ModelConfigurationPanel';
import { useGetCurrentUserQuery } from '@/services/api';

export function ModelConfigurationPage(): JSX.Element {
  const userQ = useGetCurrentUserQuery();

  if (userQ.isLoading) {
    return (
      <div className="content" style={{ paddingTop: 48 }}>
        <SkeletonRow />
        <SkeletonRow />
      </div>
    );
  }

  if (userQ.isError || !userQ.data) {
    return (
      <div className="content" style={{ paddingTop: 48 }}>
        <ErrorState
          title="Couldn't load your account"
          body="Model configuration needs your account details to check your permissions."
          onRetry={() => void userQ.refetch()}
        />
      </div>
    );
  }

  const user = userQ.data;

  if (user.role !== 'admin') {
    return (
      <>
        <h1 className="page-title">Model configuration</h1>
        <div className="card">
          <div className="empty" style={{ padding: '80px 24px' }}>
            <p className="empty-title">You don&apos;t have access to model configuration</p>
            <p className="empty-sub">
              Model rates apply to every project on this platform, so changing them is restricted
              to administrators.
            </p>
            <div className="mono-cap" style={{ marginBottom: 16 }}>
              capability required · model.manage
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <h1 className="page-title">Model configuration</h1>
      <p className="page-sub">
        Rates and model availability apply to <strong>every project</strong> on this platform.
      </p>
      <ModelConfigurationPanel canManage />
    </>
  );
}
